import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm$editingEntity$for;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("h2", {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.isAdding ? "Add" : "Edit") + " event")]), _c(VForm, {
    ref: "form",
    model: {
      value: _vm.editingEntity.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "isValid", $$v);
      },
      expression: "editingEntity.form.isValid"
    }
  }, [_c("div", {
    staticClass: "mt-4"
  }, [_c("div", {
    staticClass: "d-flex align-center"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.isPublicVisible,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "isPublicVisible", $$v);
      },
      expression: "editingEntity.form.isPublicVisible"
    }
  }), _vm.editingEntity.form.isPublicVisible ? _c("span", {
    staticClass: "text-green text-bold"
  }, [_vm._v(" Visible/accessible to everyone with the link ")]) : _c("span", {
    staticClass: "text-red text-bold"
  }, [_vm._v("Not Visible / Accessible for anyone")])], 1)]), _c(VTextField, {
    attrs: {
      label: "title for admin (not visible to users)",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.titleForAdmin,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "titleForAdmin", $$v);
      },
      expression: "editingEntity.form.titleForAdmin"
    }
  }), _c("div", {
    staticClass: "event-url-container mb-4"
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Unique event url",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty],
      hint: _vm.getUniqueEventUrl()
    },
    model: {
      value: _vm.editingEntity.form.eventUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "eventUrl", $$v);
      },
      expression: "editingEntity.form.eventUrl"
    }
  }), _c(VTooltip, {
    attrs: {
      bottom: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            color: _vm.copied ? "success" : "primary",
            elevation: "2",
            disabled: _vm.isAnyActionInProgress
          },
          on: {
            click: _vm.copyText
          }
        }, "v-btn", attrs, false), on), [_vm._v(" Copy event url "), _c("i", {
          staticClass: "fa ml-2",
          class: _vm.copied ? "fa-check" : "fa-copy",
          attrs: {
            color: "green"
          }
        })])];
      }
    }])
  }, [_c("span", [_vm._v(_vm._s(_vm.copied ? "Copied!" : "Copy event url"))])])], 1), _c("div", {
    staticClass: "bold"
  }, [_c("div", {
    staticClass: "flex justify-start"
  }, [_c("div", {
    staticClass: "flex --inline-flex cursor--pointer flex-grow--no",
    on: {
      click: function click($event) {
        _vm.chaptersVisibility.headerParagraph = !_vm.chaptersVisibility.headerParagraph;
      }
    }
  }, [_vm._v(" Header paragraph "), _c(VIcon, {
    class: ["ml-2", "fas", _vm.chaptersVisibility.headerParagraph ? "fa-angle-double-up" : "fa-angle-double-down"],
    attrs: {
      size: "0.85rem"
    }
  })], 1)])]), _vm.chaptersVisibility.headerParagraph ? [_c("div", {
    staticClass: "mt-4"
  }, [_vm._v("Logo")]), !_vm.editingEntity.form.logoUrl ? _c("UploaderV2", {
    key: "uploadLogoUrl",
    ref: "uploadLogoUrl",
    staticClass: "mt-6",
    attrs: {
      url: _vm.uploadLogoUrl,
      fileTypes: [".jpg", "jpeg", ".png"],
      label: "Attach Logo",
      multiple: false,
      hideUploadButton: ""
    }
  }) : _vm._e(), ((_vm$editingEntity$for = _vm.editingEntity.form.logoUrl) === null || _vm$editingEntity$for === void 0 ? void 0 : _vm$editingEntity$for.length) > 0 ? _c("div", {
    staticClass: "logo-uploaded-container"
  }, [_c("img", {
    staticStyle: {
      "max-width": "100%",
      "max-height": "5rem",
      cursor: "pointer"
    },
    attrs: {
      src: _vm.editingEntity.form.logoUrl,
      alt: ""
    },
    on: {
      click: function click($event) {
        return _vm.openUrl(_vm.editingEntity.form.logoUrl);
      }
    }
  }), _c(VIcon, {
    staticClass: "fa fa-external-link-alt icon-link",
    attrs: {
      size: "1rem",
      title: "Open logo in new tab"
    },
    on: {
      click: function click($event) {
        return _vm.openUrl(_vm.editingEntity.form.logoUrl);
      }
    }
  }), _c(VIcon, {
    staticClass: "fa fa-trash icon-link",
    attrs: {
      size: "1rem",
      title: "Delete logo"
    },
    on: {
      click: _vm.confirmLogoDelete
    }
  })], 1) : _vm._e(), _c(VTextarea, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "First paragraph",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.firstParagraph,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "firstParagraph", $$v);
      },
      expression: "editingEntity.form.firstParagraph"
    }
  }), _c(VDivider, {
    staticClass: "my-6"
  }), _c(VTextField, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Mail to button title",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.mailToTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "mailToTitle", $$v);
      },
      expression: "editingEntity.form.mailToTitle"
    }
  }), _vm.editingEntity.form.mailToTitle ? _c(VTextField, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Mail to email address",
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeEmail]
    },
    model: {
      value: _vm.editingEntity.form.mailToEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "mailToEmail", $$v);
      },
      expression: "editingEntity.form.mailToEmail"
    }
  }) : _vm._e(), _c(VDivider, {
    staticClass: "my-6"
  }), _c(VCheckbox, {
    staticClass: "cursor--forbidden",
    attrs: {
      label: "Second paragraph",
      "hide-details": "auto"
    },
    on: {
      change: _vm.resetSecondParagraph
    },
    model: {
      value: _vm.editingEntity.secondParagraphVisible,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity, "secondParagraphVisible", $$v);
      },
      expression: "editingEntity.secondParagraphVisible"
    }
  }), _vm.editingEntity.secondParagraphVisible ? _c(VTextField, {
    attrs: {
      label: "second paragraph title",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.secondParagraphTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "secondParagraphTitle", $$v);
      },
      expression: "editingEntity.form.secondParagraphTitle"
    }
  }) : _vm._e(), _vm.editingEntity.secondParagraphVisible ? _c(VTextarea, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Second paragraph",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.secondParagraph,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "secondParagraph", $$v);
      },
      expression: "editingEntity.form.secondParagraph"
    }
  }) : _vm._e()] : _vm._e(), _c(VDivider, {
    staticClass: "my-6"
  }), _c("div", {
    staticClass: "bold"
  }, [_c("div", {
    staticClass: "flex justify-start"
  }, [_c("div", {
    staticClass: "flex --inline-flex cursor--pointer flex-grow--no",
    on: {
      click: function click($event) {
        _vm.chaptersVisibility.essentialInfo = !_vm.chaptersVisibility.essentialInfo;
      }
    }
  }, [_vm._v(" Essential Informations "), _c(VIcon, {
    class: ["ml-2", "fas", _vm.chaptersVisibility.essentialInfo ? "fa-angle-double-up" : "fa-angle-double-down"],
    attrs: {
      size: "0.85rem"
    }
  })], 1)])]), _vm.chaptersVisibility.essentialInfo ? [_c(VTextField, {
    attrs: {
      label: "Left text",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: []
    },
    model: {
      value: _vm.editingEntity.form.leftText,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "leftText", $$v);
      },
      expression: "editingEntity.form.leftText"
    }
  }), _vm.editingEntity.form.leftText ? _c(VTextField, {
    attrs: {
      label: "Left text link",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeHttpLinkOrEmpty]
    },
    model: {
      value: _vm.editingEntity.form.leftTextLink,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "leftTextLink", $$v);
      },
      expression: "editingEntity.form.leftTextLink"
    }
  }) : _vm._e(), _c(VTextField, {
    attrs: {
      label: "Right text",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.rightText,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "rightText", $$v);
      },
      expression: "editingEntity.form.rightText"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Right text link",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeHttpLinkOrEmpty]
    },
    model: {
      value: _vm.editingEntity.form.rightTextLink,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "rightTextLink", $$v);
      },
      expression: "editingEntity.form.rightTextLink"
    }
  }), _c(VTextarea, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Bottom smaller text",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.bottomSmallerText,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "bottomSmallerText", $$v);
      },
      expression: "editingEntity.form.bottomSmallerText"
    }
  })] : _vm._e(), _c(VDivider, {
    staticClass: "my-6"
  }), _c("div", {
    staticClass: "bold"
  }, [_c("div", {
    staticClass: "flex justify-start"
  }, [_c("div", {
    staticClass: "flex --inline-flex cursor--pointer flex-grow--no",
    on: {
      click: function click($event) {
        _vm.chaptersVisibility.primaryAction = !_vm.chaptersVisibility.primaryAction;
      }
    }
  }, [_vm._v(" Primary Action "), _c(VIcon, {
    class: ["ml-2", "fas", _vm.chaptersVisibility.primaryAction ? "fa-angle-double-up" : "fa-angle-double-down"],
    attrs: {
      size: "0.85rem"
    }
  })], 1)])]), _vm.chaptersVisibility.primaryAction ? [_c(VTextField, {
    attrs: {
      label: "Primary button text",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: []
    },
    model: {
      value: _vm.editingEntity.form.primaryButtonText,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "primaryButtonText", $$v);
      },
      expression: "editingEntity.form.primaryButtonText"
    }
  }), _vm.editingEntity.form.primaryButtonText ? _c(VTextField, {
    attrs: {
      label: "Primary button link",
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeHttpLinkOrEmpty]
    },
    model: {
      value: _vm.editingEntity.form.primaryButtonLink,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "primaryButtonLink", $$v);
      },
      expression: "editingEntity.form.primaryButtonLink"
    }
  }) : _vm._e()] : _vm._e(), _c(VDivider, {
    staticClass: "my-6"
  }), _c("div", {
    staticClass: "bold"
  }, [_c("div", {
    staticClass: "flex justify-start"
  }, [_c("div", {
    staticClass: "flex --inline-flex cursor--pointer flex-grow--no",
    on: {
      click: function click($event) {
        _vm.chaptersVisibility.footerParagraph = !_vm.chaptersVisibility.footerParagraph;
      }
    }
  }, [_vm._v(" Footer paragraph "), _c(VIcon, {
    class: ["ml-2", "fas", _vm.chaptersVisibility.footerParagraph ? "fa-angle-double-up" : "fa-angle-double-down"],
    attrs: {
      size: "0.85rem"
    }
  })], 1)])]), _vm.chaptersVisibility.footerParagraph ? [_c(VTextarea, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Small paragraph",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editingEntity.form.footerParagraph,
      callback: function callback($$v) {
        _vm.$set(_vm.editingEntity.form, "footerParagraph", $$v);
      },
      expression: "editingEntity.form.footerParagraph"
    }
  })] : _vm._e(), _c(VDivider, {
    staticClass: "my-6"
  }), _c("div", {
    staticClass: "text-center my-6"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small danger mr-6",
    attrs: {
      rounded: "",
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.deleteEvent();
      }
    }
  }, [_vm._v(" Delete ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.cancelEvent();
      }
    }
  }, [_vm._v(" Cancel ")]), !_vm.isAdding && _vm.editingEntity.form.isPublicVisible ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isAnyActionInProgress,
      disabled: !_vm.editingEntity.form.isValid
    },
    on: {
      click: function click($event) {
        _vm.openUrl(_vm.getUniqueEventUrl());
      }
    }
  }, [_vm._v(" View event page "), _c(VIcon, {
    staticClass: "fa fa-external-link-alt icon-link ml-2",
    attrs: {
      size: ".8rem",
      title: "Open preview in new tab"
    }
  })], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isAnyActionInProgress,
      disabled: !_vm.editingEntity.form.isValid
    },
    on: {
      click: _vm.saveEvent
    }
  }, [_vm._v(" Save ")])], 1)], 2), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };